import { render, staticRenderFns } from "./zdrugsynDetail.vue?vue&type=template&id=75d2aaaa&scoped=true"
import script from "./zdrugsynDetail.vue?vue&type=script&lang=js"
export * from "./zdrugsynDetail.vue?vue&type=script&lang=js"
import style0 from "./zdrugsynDetail.vue?vue&type=style&index=0&id=75d2aaaa&prod&scoped=true&lang=css"
import style1 from "./zdrugsynDetail.vue?vue&type=style&index=1&id=75d2aaaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d2aaaa",
  null
  
)

export default component.exports